<section class="ts-schedule" id="registration">
  <div class="container">
    <div class="row mt-5">
      <div class="col-lg-12 text-center">
        <h2 class="section-title">Registration</h2>
      </div>
      <!-- col end-->
    </div>
    <!-- row end-->
    <div class="row">
      <div class="col-lg-12 text-center">
        <div class="tab-content schedule-tabs">
          <div role="tabpanel" class="tab-pane active" id="date3">
            <!--schedule-listing end -->

            <div class="row alert alert-success text-center">
              Thank you for registration, Please check your inbox, spam or junk
              for the password.
            </div>
            <a [routerLink]="['/']" class="btn btn-success"
              >Check here to login
            </a>
            <!--schedule-listing end -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- container end-->
  <div class="speaker-shap">
    <img class="shap2" src="images/shap/home_schedule_memphis1.png" alt="" />
    <img class="shap1" src="images/shap/home_schedule_memphis2.png" alt="" />
  </div>
</section>
